import { lazy } from 'react';

const popups = {
  signOut: lazy(() => import('./signOut')),
  createTeam: lazy(() => import('./createTeam')),
  addTeamMember: lazy(() => import('./addTeamMember')),
  forgotPassword: lazy(() => import('./forgotPassword')),
  joinMatch: lazy(() => import('./joinMatch')),
  manageSquad: lazy(() => import('./manageSquad')),
  seatDraw: lazy(() => import('./seatDraw')),
};

export default popups;
